<template>
  <!-- 직원 권한 정기 확인(6개월, T-CONTRACT-1031 §2). 규칙은 utils/permReview.js -->
  <a-modal :open="!!state.rows" :title="TEXT.title" :footer="null" :width="720" :maskClosable="false" @cancel="review.later">
    <p class="perm-review__guide">{{ TEXT.guide }}</p>
    <div class="perm-review__list">
      <table class="perm-review__table">
        <thead>
          <tr>
            <th>이름</th>
            <th>아이디</th>
            <th>마지막 로그인</th>
            <th>켜진 메뉴</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="r in state.rows || []" :key="r.accountId">
            <td>{{ r.name }}</td>
            <td>{{ r.username }}</td>
            <td>
              {{ r.lastLogin }}
              <a-tag v-if="r.inactive90" color="orange">{{ TEXT.inactive }}</a-tag>
            </td>
            <td>{{ r.menus }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="perm-review__footer">
      <a-button :disabled="state.busy" @click="review.later">{{ TEXT.later }}</a-button>
      <a-button type="primary" :loading="state.busy" @click="review.confirm">{{ TEXT.confirm }}</a-button>
    </div>
  </a-modal>
</template>

<script>
// App.vue 에 하나 — active(로그인 뒤 껍데기)일 때 탭·계정마다 한 번 묻는다. 지원 탭·studio 안(iframe)에서는 묻지 않음(studio 가 따로 물음).
// 흐름(세션 바뀜·늦은 답·다른 탭 로그인)은 utils/permReview.js 의 createPermReview. 여기는 버튼·이동·storage 이벤트를 넘기기만.
// 요청은 silent — axios 가 어떤 오류도 알리지 않고 그대로 실패시킨다(403·503 포함).
import apiInstance from "@/axios";
import { LEGACY_KEYS, SUPPORT_KEYS, getAccessToken, isSupportTab } from "@/utils/tokenStore";
import { isStudioEmbed } from "@/utils/studioEmbed";
import { PERM_REVIEW_STATUS_URL, PERM_REVIEW_TEXT, PERM_REVIEW_URL, createPermReview } from "@/utils/permReview";

const SILENT = { silent: true, showGlobalLoading: false };

export default {
  name: "PermReviewModal",
  props: {
    active: { type: Boolean, default: false },
  },
  data() {
    return { TEXT: PERM_REVIEW_TEXT, state: { rows: null, busy: false } };
  },
  created() {
    this.review = createPermReview({
      state: this.state,
      storage: sessionStorage,
      readToken: getAccessToken,
      isActive: () => !isStudioEmbed() && this.active,
      isSupportTab,
      get: async () => (await apiInstance.get(PERM_REVIEW_STATUS_URL, SILENT)).data,
      post: (body) => apiInstance.post(PERM_REVIEW_URL, body, SILENT),
      tokenKeys: [LEGACY_KEYS.access, SUPPORT_KEYS.access, SUPPORT_KEYS.session],
    });
    // 지켜보기는 review 가 생긴 뒤부터(immediate 감시는 created 전에 돌아서 쓰지 않음)
    this.check();
  },
  watch: {
    active: "check",
    $route: "check",
  },
  mounted() {
    // 다른 탭의 로그인·로그아웃(토큰·지원 키 바뀜) — 토큰 주인이 바뀌었으면 창을 닫는다
    window.addEventListener("storage", this.review.onStorage);
  },
  beforeUnmount() {
    window.removeEventListener("storage", this.review.onStorage);
  },
  methods: {
    check() {
      this.review.check();
    },
  },
};
</script>

<style scoped>
.perm-review__guide {
  margin: 0 0 12px;
  color: #6b7280;
  font-size: 13px;
}
.perm-review__list {
  max-height: 360px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}
.perm-review__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.perm-review__table th,
.perm-review__table td {
  padding: 8px 10px;
  border-bottom: 1px solid #e5e7eb;
  text-align: left;
  vertical-align: top;
}
/* 이름·아이디·마지막 로그인은 한 줄로(좁으면 「정다운」이 한 글자씩 꺾임, 10-31 intest I14) */
.perm-review__table th:nth-child(-n + 3),
.perm-review__table td:nth-child(-n + 3) {
  white-space: nowrap;
}
.perm-review__table th {
  position: sticky;
  top: 0;
  background: #f9fafb;
  font-weight: 600;
}
.perm-review__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
}
</style>
